<template>
<div id="container" class="geschichte_200602">
    <div class="fullscreen_background">
        <img src="/static/assets/geschichte_200602/Hintergrund_2860.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/geschichte_200602/Moeve.png" />
    </div> -->

    <div class="Kolibri z30">
        <!-- <img class="img" src="/static/assets/geschichte_200602/Schwimmer.png" /> -->
        <img class="img" src="/static/assets/geschichte_200602/wurm_anim_2.png" />
    </div>
    <div class="lianen_joe z30">
        <img class="img" src="/static/assets/geschichte_200602/Hugi_Hutzl.png" />
    </div>
    <div class="baer z30">
        <img class="img" src="/static/assets/geschichte_200602/libero_tuete_anim_2.png" />
    </div>
    <div class="hugi z30">
        <img class="img" src="/static/assets/geschichte_200602/Gigi_Gloeckchen.png" />
    </div>
	<div class="gigi z30">
        <img class="img" src="/static/assets/geschichte_200602/Dubix_Pappel.png" />
    </div>
    <div class="dubix z30">
        <img class="img hovering4" src="/static/assets/geschichte_200602/Biene_bitte_Schweben_Lassen.png" />
    </div>
    <div class="blubber blubber_animation z29">
    </div>
	<div class="wassergeist z30 wassergeist_animation">
    </div>
    <router-link to="/geschichte_200601" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil.png" />
    </router-link>

    <router-link to="/geschichte_200603" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/geschichte_200602/Textfeld.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_2_Dubix_Pappel.mp3" jsonurl="/static/assets/geschichten/dubix_ausgabe_5.json" content=".geschichte_200602" target="geschichte_200602_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="geschichte_200602_target">
        <p>Die Sonne lachte durch die Zweige der Bäume hindurch und ließ kleine flirrende Lichtpunkte auf dem grünen Moosteppich vor Hugi Hutzls Häuschen tanzen. „Das ist ein schöner Morgen, den will ich mir gerne gefallen lassen“, rief Hugi Hutzl und setzte sich mit einer leckeren Holunderlimonade in der Hand auf seine Hausbank. Es dauerte nicht lange, da trat aus der Nachbarbaumhöhle Wichtelhexe Gigi Glöckchen, mit ihrem Kieferbesen in der Hand. „Guten Morgen, Hugi Hutzl!“, rief sie und fegte lautstark vor ihrer Haustür. „Heute ist ein guter Tag zum Pilzesammeln.“ „Wohl wahr, liebe Nachbarin, aber setz dich noch ein Weilchen zu mir und sag Frau Sonne guten Tag.“</p> 
<p>„Pfft! Dieser Hugi Hutzl“, raunzte Gigi Glöckchen vor sich hin, „so ein Faulbär! Als ob Frau Sonne uns Waldwichtel verstünde! Ja gut, uns Waldwichtel gibt es so lange wie den Wald, also eigentlich hat es uns schon immer gegeben. Doch ob die Sonne Waldwichtel versteht, wer konnte das wissen?“ Nicht einmal Dubix Pappel, der uralte Waldgeist, wusste darauf eine Antwort. Gigi Glöckchen betrat ihr Baumhöhlenhäuschen und sog zufrieden den Duft der getrockneten Beeren ein, die sie in ihren Vorratsregalen gestapelt hatte. Ja, sie war fleißig gewesen, der Winter konnte kommen. Doch noch ein paar Pilze für ihren Zaubertee konnten nicht schaden. Sie machte sich auf zum Pfifferlingsweg und nahm ein großes, langstieliges Eichenblatt mit. Darauf wollte sie einen der buttergelben Pilze legen, ihn nachhause ziehen, zersägen und dann trocknen.</p>
<p>Gerade wollte sie die Hirschkuhlichtung überqueren, als sie ein ungewohntes Knistern hörte. So knisterte Laub nicht! Was war das? Gigi Glöckchen blickte sich um. Unter der Himbeerhecke lag etwas! Sie näherte sich – und schrie auf. Es war Waldschrat Libero Zapf, in einem durchsichtigen Etwas gefangen, aus dem er sich vergebens zu befreien suchte. Gigi Glöckchen hörte hinter sich Schritte. Hugi Hutzl hatte ihren Schrei gehört und war hierhergeeilt. „Plastik!“, stellte er entsetzt fest. „Schnell, wir müssen ihn befreien.“ Aus seinem Körbchen holte er einen Brombeerdorn und es gelang ihnen, Libero Zapf aus der Plastikhülle herauszuschneiden. Nach Atem ringend lag der kleine Waldschrat da. „Ich bin wegen ein paar leckerer Krümel hineingekrochen und habe nicht wieder herausgefunden.“</p>
<p>„Diese Waldbesucher! Warum konnten diese Riesen ihre Siebensachen nicht wieder einpacken und sich trollen?“, seufzte Hugi Hutzl. „Stattdessen“, tönte es plötzlich von oben, „schaut euch das an!“ Oben auf der Spitze einer Fichte saß Dubix Pappel, der Waldgeist. Auch er hatte den Schrei gehört und war herbeigeflogen. Tatsächlich lag die ganze Lichtung voller Zeugs, das die Riesen zurückgelassen hatten. Neugierig sahen sie sich die Dinge an. „Ein Häuschen, ein ganzes Häuschen haben sie vergessen“, staunte Gigi Glöckchen. „Das ist ein Becher, das nehmen sie zum Trinken“, erklärte Dubix Pappel. Gigi schüttelte ungläubig den Kopf. Tatsächlich hatte sie vergessen, wie groß die Riesen waren. „Und das?“, fragte Hugi Hutzl und kletterte auf einen dicken Klotz. „Was ist das?“ Geduldig antwortete Dubix Pappel: „Das nennen sie Buch. Darin sperren sie Geschichten ein.“ „Das passt zu diesen dusseligen Riesen: Waldschrate und Geschichten einsperren!“, schimpfte Hugi Hutzl. Plötzlich bebte die Erde. Eine ganze Horde Riesen kam gelaufen. Schnell wie der Waldwind versteckten sich die vier Waldbewohner unter Gigi Glöckchens Eichenblatt.</p> 
<p>„Da ist es!“, rief eine rote Riesin. Liest du uns jetzt vor?“ „Erst wenn ihr die Plastiktüte wegräumt. Wie oft habe ich euch schon gesagt, dass diese Dinge im Wald nichts verloren haben!“, antwortete ihr die Riesin der Riesen. Der gelbe Riese sah verwundert die zerschnittene Tüte an, stopfte sie aber schnell in seine Tasche „Jetzt?!“ Da klappte die Riesin der Riesen den dicken Klotz auf und ließ eine Geschichte frei. Gebannt lauschten die Waldbewohner ihr unter dem Eichenblatt und vergaßen darüber die Pfifferlinge, den kommenden Winter und wie dusselig Riesen waren. „Hoffentlich kommen sie bald wieder!“, sagte Gigi Glöckchen und blickte den vier Riesen sehnsuchtsvoll nach, nachdem diese die Lichtung aufgeräumt hatten und gegangen waren. Dubix Pappel nickte. „Gewiss“, sagte er, „gewiss!“</p> 
<p>In der darauffolgenden Nacht schlich sich ein Waldgeist in die Träume der Riesen und sie versprachen ihm, immer wieder in den Wald zu kommen und vorzulesen. So sagen heute alle, selbst die allerwinzigsten Waldwesen:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'geschichte_200602',
  data () {
    return {
      who: 'geschichte_200602'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Dubix_Titel_Dubix_Pappel.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dubix_Pappel_Atmo_II.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* geschichte_200602 */
.geschichte_200602 { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.geschichte_200602 .himmel { display: block !important; }

.geschichte_200602 .geschichte { position: absolute; top: 170px; left:51%;  }

.geschichte_200602 .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.geschichte_200602 .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* geschichte_200602 .schwimmer {position: absolute; left: 28%; top: 39%; } */
.geschichte_200602 .schwimmer {position: absolute; left: 25%; top: 12%; }
.geschichte_200602 .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.geschichte_200602 .fuchs_animation {
  width: 122px !important;
  height: 204px !important;
  background: url('/static/assets/geschichte_200602/Wassergeist_Animation.png') top center;
  animation: fuchs_animation 3s steps(15) infinite;
  animation-delay: 0.4s;
  transform: scale(1);
}
.geschichte_200602 .baer {position: absolute; /* left: 36%; top: 74%; */ left: -474px; top: -299px;}
.geschichte_200602 .baer {animation: baer_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes baer_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.geschichte_200602 .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.geschichte_200602 .lianen_joe {position: absolute; left: 346px;
    bottom: 268px;}
.geschichte_200602 .lianen_joe {animation: lianen_joe_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes lianen_joe_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.geschichte_200602 .koechin {position: absolute; left: 37%; bottom: 26%;}
.geschichte_200602 .hugi {position: absolute;
    right: 1347px;
    bottom: 505px;}
.geschichte_200602 .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .geschichte_200602 .dubix {position: absolute; left: 309px;
    bottom: 729px;}
.geschichte_200602 .dubix {animation: hugi_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.geschichte_200602 .Kolibri {position: absolute; right: -542px;
    bottom: -202px;}
/* .geschichte_200602 .Kolibri {animation: schwimmen 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;} */
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .geschichte_200602 .gigi {position: absolute;     left: 672px;
    bottom: 17px; }
.geschichte_200602 .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.geschichte_200602 .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.geschichte_200602 .moeve { position: absolute; top: 250px; left: 600px; }
.geschichte_200602 .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  25% {
    -ms-transform: translate(20px,30px);
    -moz-transform: translate(20px,30px);
    -webkit-transform: translate(20px,30px);
    -o-transform: translate(20px,30px);
    transform: translate(20px,30px);
  }
  50% {
    -ms-transform: translate(-10px,10px);
    -moz-transform: translate(-10px,10px);
    -webkit-transform: translate(-10px,10px);
    -o-transform: translate(-10px,10px);
    transform: translate(-10px,10px);
  }
  75% {
    -ms-transform: translate(-20px,-20px); 
    -moz-transform: translate(-20px,-20px); 
    -webkit-transform: translate(-20px,-20px);
    -o-transform: translate(-20px,-20px);
    transform: translate(-20px,-20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.geschichte_200602 .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.geschichte_200602 .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.geschichte_200602 .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.geschichte_200602 .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.geschichte_200602 .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.blubber.blubber_animation {
    top: -25%;
    left: -25%;
    position: absolute;
}
.blubber_animation {
  width: 2880px;
  height: 1620px;
  background: url('/static/assets/geschichte_200602/Blubber_Animation.png') top center;
  animation-delay: 1s;
  animation: blubber_animation 2s steps(6) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes blubber_animation {
    100% { background-position: 0 -9720px; }
}
.geschichte_200602 .wassergeist {position: absolute; top: 871px; left: 10px;}
.wassergeist_animation {
  width: 122px;
  height: 204px;
  background: url('/static/assets/geschichte_200602/Wassergeist_Animation.png') top center;
  animation-delay: 1s;
  animation: wassergeist_animation 15s steps(15) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wassergeist_animation {
    0% { background-position: 0 -0px; }
    10% { background-position: 0 -3060px; }
    100% { background-position: 0 -3060px; }
}	
span { font-family: FrozenMemory; } 
.player {
    position: absolute;
    top: 660px !important;
    left: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Geschichte_200602.vue